import { render } from "./MypageLikeButton.vue?vue&type=template&id=f4ae3de4"
import script from "./MypageLikeButton.vue?vue&type=script&lang=js"
export * from "./MypageLikeButton.vue?vue&type=script&lang=js"

import "./MypageLikeButton.vue?vue&type=style&index=0&id=f4ae3de4&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__